<template>
    <div class="content-wrapper">

        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb
                page-title="Revisión Solicitud de Registro"
                directory="Información"
                :icon="'trello'"
                />
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <a href="/register/users/pending" class="btn btn-primary">Volver</a>
                </div>
            </div>
        </div>

        <div class="card card-with-shadow border-0 mb-primary">
            <div class="card-body">
                <form  ref="form" class="mb-0"
                        data-url="/register/users/organization"
                        enctype="multipart/form-data"
                        :class="{'loading-opacity': preloader}"
                        >

                    <fieldset class="form-group">

                        <div class="card card-with-shadow border-0 mb-primary">
                            <div class="card-header p-primary bg-transparent">
                                <h5 class="card-title m-0">Información de la Compañia</h5>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('company_name') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.company_name"
                                            :required="true"
                                            :read-only="true"
                                            :placeholder="$t('type_company_name')"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('social_reason') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.social_reason"
                                            :required="true"
                                            :read-only="true"
                                            :placeholder="$t('type_social_reason')"/>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('ruc') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.ruc"
                                            :min-length=0
                                            :max-length=20
                                            :required="true"
                                            :read-only="true"
                                            v-on:keypress="isNumber"
                                            :placeholder="$t('type_ruc')"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('kind_society') }}</label>
                                            <app-input class="col-sm-8"
                                                type="radio-buttons"
                                                :disabled="true"
                                                v-model="inputs.society_type"
                                                :list="kindOfSocietyLists"
                                                :required="true"/>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('email') }}</label>
                                    <app-input type="email"
                                            v-model="inputs.email"
                                            :required="true"
                                            :read-only="true"
                                            :placeholder="$t('type_email')"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('company_address') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.company_address"
                                            :required="true"
                                            :read-only="true"/>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="form-group mb-2">
                                    <label>{{ $t('country') }}</label>
                                    <app-input type="select"
                                            v-model="inputs.country_id"
                                            :required="true"
                                            :disabled="true"
                                            :list="countryList"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mb-2">
                                    <div v-if="inputs.province_id">
                                        <label>{{ $t('province') }}</label>
                                        <app-input type="select"
                                                v-model="inputs.province_id"
                                                :required="true"
                                                :disabled="true"
                                                :list="provinceList"/>
                                    </div>
                                    <div v-if="!inputs.province_id">
                                        <label>{{ $t('Ciudad') }}</label>
                                        <app-input type="text"
                                            v-model="inputs.city"
                                            :disabled="true"
                                            :placeholder="$t('Ingrese Ciudad')"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div v-if="inputs.canton_id">
                                        <label>{{ $t('canton') }}</label>
                                        <app-input type="select"
                                                v-model="inputs.canton_id"
                                                :required="true"
                                                :disabled="true"
                                                :list="cantonList"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('phone') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.phone"
                                            :required="true"
                                            :disabled="true"
                                            :placeholder="$t('type_phone')"/>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="inputs.phone_extension">
                                <div class="form-group">
                                <label>{{ $t("Extensión") }}</label>
                                <app-input
                                    type="text"
                                    v-model="inputs.phone_extension"
                                    :required="false"
                                    :disabled="true"
                                    :placeholder="$t('Extensión telefónica')"
                                />
                                </div>
                            </div>
                        </div>

                    </fieldset>

                    <fieldset class="form-group">

                        <div class="card card-with-shadow border-0 mb-primary">
                            <div class="card-header p-primary bg-transparent">
                                <h5 class="card-title m-0">{{ $t('legal_rep') }}</h5>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('first_name') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.first_name"
                                            :required="true"
                                            :read-only="true"
                                            :placeholder="$t('type_names')"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('last_name') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.last_name"
                                            :required="true"
                                            :read-only="true"
                                            :placeholder="$t('type_lastname')"/>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('taxid_legal_rep') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.taxid_legal_rep"
                                            :min-length=5
                                            :max-length=20
                                            v-on:keypress="isNumber"
                                            :required="true"
                                            :read-only="true"
                                            :placeholder="$t('type_ci')"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('email') }}</label>
                                    <app-input type="email"
                                            v-model="inputs.email_legal_rep"
                                            :required="true"
                                            :read-only="true"
                                            :placeholder="$t('type_email')"/>
                                </div>
                            </div>
                        </div>

                    </fieldset>

                    <div class="card card-with-shadow border-0 mb-primary">
                        <div class="card-header p-primary bg-transparent">
                            <h5 class="card-title m-0">Adjuntos</h5>
                        </div>
                        <div class="card-body">

                            <div class="form-group mb-primary row align-items-center">
                                <label class="col-sm-2 mb-sm-0">
                                    <label>{{ $t('taxid') }}</label>
                                </label>
                                <div class="col-sm-8">
                                    <a :href="inputs.attach_ruc" class="btn btn-primary" target="_blank">
                                        <app-icon name="file"></app-icon> Ver
                                    </a>
                                </div>
                            </div>

                            <div class="form-group mb-primary row align-items-center">
                                <label class="col-sm-2 mb-sm-0">
                                    <label>{{ $t('taxid_ci') }}</label>
                                </label>
                                <div class="col-sm-8">
                                    <a :href="inputs.attach_taxid" class="btn btn-primary" target="_blank">
                                        <app-icon name="file"></app-icon> Ver
                                    </a>
                                </div>
                            </div>

                            <div class="form-group mb-primary row align-items-center">
                                <label class="col-sm-2 mb-sm-0">
                                    <label>{{ $t('legal_rep_attach') }}</label>
                                </label>
                                <div class="col-sm-8">
                                    <a :href="inputs.attach_legalrep" class="btn btn-primary" target="_blank">
                                        <app-icon name="file"></app-icon> Ver
                                    </a>
                                </div>
                            </div>

                            <div class="form-group mb-primary row align-items-center" v-if="inputs.attach_agreement">
                                <label class="col-sm-2 mb-sm-0">
                                    <label>{{ $t('agreement') }}</label>
                                </label>
                                <div class="col-sm-8">
                                    <a :href="inputs.attach_agreement" class="btn btn-primary" target="_blank">
                                        <app-icon name="file"></app-icon> Ver
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>

                    <fieldset class="form-group">

                        <div class="card card-with-shadow border-0 mb-primary">
                            <div class="card-header p-primary bg-transparent">
                                <h5 class="card-title m-0">Aprobación del Registro</h5>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Comentarios</label>
                                    <app-input type="textarea"
                                                v-model="inputs.comments"
                                                :required="true"/>
                                </div>
                            </div>
                        </div>

                    </fieldset>

                    <div class="mt-5">
                        <button type="submit" class="btn btn-success mr-2" @click.prevent="submit(true)">
                            <i data-feather="check" class="pr-2"/>Aprobar
                        </button>
                        <button type="submit" class="btn btn-danger mr-2" @click.prevent="submit(false)">
                            <i data-feather="x" class="pr-2"/>Rechazar
                        </button>
                    </div>

                </form>
            </div>
        </div>

    </div>
</template>

<script>
    import { FormMixin } from "@/core/mixins/form/FormMixin.js";
    import * as actions from "../../../apiUrl";

    export default {
        name: "Form",
        mixins: [FormMixin],
        props: {
            orgId: String,
            backUrl: {
                type: String,
                default: '/'
            }
        },
        data() {
            return {
                url: "",
                preloader: false,
                showCity: false,
                rucFile: "Seleccionar Archivo",
                taxidFile: "Seleccionar Archivo",
                legalRepFile: "Seleccionar Archivo",
                agreementFile: "Seleccionar Archivo",
                selectedSocietyType: '',
                inputs: { },
                kindOfSocietyLists: [
                    {id: 'private', value: "Sociedad Privada"},
                    {id: 'public', value: "Sociedad Pública"},
                    {id: 'other', value: "Otro"}
                ],
                countryLists: [],
                countryList: [
                    {id: '',value: "Seleccione País"},
                ],
                provinceLists: [],
                provinceList: [
                    {id: "",value: "Seleccione Provincia" }
                ],
                cantonLists: [],
                cantonList: [
                    {id: "",value: "Seleccione Canton" }
                ]
            }
        },
        created() {
            this.data();
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit(approval) {
                if(approval){
                    this.inputs.is_approved = true;
                }else{
                    this.inputs.is_approved = false;
                }
                this.inputs.id = this.orgId;
                this.save(this.inputs);
            },
            afterSuccess(response) {
                this.preloader = true;
                if (response.status == 200) {
                    window.location = '/register/users/pending';
                }
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            getInfo() {
                this.preloader = true;
                let url = `${actions.COMMON_POLITICAL_DIVISION}`;
                this.axiosGet(url)
                    .then((response) => {
                        if (response.status == 200) {
                            this.countryLists = response.data.countries;
                            this.countryList = [
                                ...this.countryLists.filter((item) => {
                                    return item;
                                }),
                            ];
                            this.provinceLists = response.data.provinces;
                            this.provinceList = [
                                ...this.provinceLists.filter((item) => {
                                    return item;
                                }),
                            ];
                            this.cantonLists = response.data.cantons;
                            this.cantonList = [
                                ...this.cantonLists.filter((item) => {
                                    return item;
                                }),
                            ];
                        }
                    })
                    .catch(({ error }) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.preloader = false;
                    });
            },
            data() {
                this.preloader = true;
                let url = `${actions.USERS_REGISTER}/form/${this.orgId}`;
                this.axiosGet(url)
                    .then((response) => {
                        if (response.status == 200) {
                            this.inputs.company_name = response.data.organization.name;
                            this.inputs.social_reason = response.data.organization.business_name;
                            this.inputs.ruc = response.data.organization.taxid;
                            this.inputs.society_type = response.data.organization.organization_type;
                            this.inputs.email = response.data.organization.email;
                            this.inputs.company_address = response.data.organization.address;
                            this.inputs.phone = response.data.organization.phone;
                            this.inputs.country_id = response.data.organization.country_id;
                            this.inputs.province_id = response.data.organization.province_id;
                            this.inputs.canton_id = response.data.organization.canton_id;
                            this.inputs.city = response.data.organization.city;
                            this.inputs.user_id = response.data.organization.user.id;
                            this.inputs.first_name = response.data.organization.user.first_name;
                            this.inputs.last_name = response.data.organization.user.last_name;
                            this.inputs.email_legal_rep = response.data.organization.user.email;
                            this.inputs.taxid_legal_rep = response.data.organization.legal_representative_taxid;
                            this.inputs.phone_extension = response.data.organization.phone_extension;
                            for (let i = 0; i < response.data.organization.user.file.length; i++) {
                                if(response.data.organization.user.file[i].type === 'ruc'){
                                    this.inputs.attach_ruc = response.data.organization.user.file[i].full_url;
                                }
                                if(response.data.organization.user.file[i].type === 'taxid'){
                                    this.inputs.attach_taxid = response.data.organization.user.file[i].full_url;
                                }
                                if(response.data.organization.user.file[i].type === 'legalrep'){
                                    this.inputs.attach_legalrep = response.data.organization.user.file[i].full_url;
                                }
                                if(response.data.organization.user.file[i].type === 'agreement'){
                                    this.inputs.attach_agreement = response.data.organization.user.file[i].full_url;
                                }
                            }
                            this.getInfo();
                        }
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    })
                    .finally(() => {
                        this.preloader = false;
                    });
            }
        }
    };
</script>
